import moment from 'moment';
import React from 'react';
interface IDDate {
    date: Date | undefined;
    format?: string;
    ago?: boolean;
}
const DateDisplay: React.FunctionComponent<IDDate> = props => {
    const format: string = props.format ? props.format : 'DD/MM/YYYY H:mm:s'
    return <>
        {props.date !== undefined && <>

            {moment(props.date).format(format)}

            {props.ago === true && <> - {moment(props.date).fromNow()}</>}

        </>}


    </>
};


export default DateDisplay